export enum PositionStatus {
  Gemeldet = 'GEMELDET',
  InPruefung = 'IN_PRUEFUNG',
  Erfasst = 'ERFASST',
  // V2: Genehmigt = 'GENEHMIGT',
  // V2: Abgelehnt = 'ABGELEHNT',
}
